import { useState, useEffect, useRef } from 'react'
import { setPreference, getPreference } from '../services/indexeddb-service'

export function usePersistedState<T>(key: string, defaultValue: T): [T, (value: T) => void] {
  const [value, setValue] = useState<T>(defaultValue)
  const loadedRef = useRef(false)

  useEffect(() => {
    getPreference<T>(key).then((stored: T | undefined) => {
      if (stored !== undefined) {
        setValue(stored)
      }
      loadedRef.current = true
    })
  }, [key])

  const setAndPersist = (newValue: T) => {
    setValue(newValue)
    if (loadedRef.current) {
      setPreference(key, newValue)
    }
  }

  return [value, setAndPersist]
}
